export const resolveUrl = (path: string, options: Record<string, string | number | null | undefined>): string | null => {
  const placeholders = path.match(/\[([^\]]+)]/g)
  if (!placeholders) return path

  for (const placeholder of placeholders) {
    const key = placeholder.slice(1, -1)
    const v = options[key]
    if (v === null || v === undefined || v === '') return null
  }

  return path.replace(/\[([^\]]+)]/g, (_, key: string) => String(options[key]))
}
